import { upload } from "@vercel/blob/client";
import { authFetch } from "../../HttpClient";

// Appels à l'API Base de connaissance (backend-myalfa, /api/kb).
const BASE = "https://backend-myalfa.vercel.app/api/kb";

async function appel(url, options) {
  const res = await authFetch(url, {
    ...options,
    headers: { "Content-Type": "application/json", ...(options && options.headers) },
  });
  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    try {
      message = (await res.json()).message || message;
    } catch (e) {
      // corps non JSON : on garde le statut
    }
    throw new Error(message);
  }
  return res.json();
}

const corps = (body) => JSON.stringify(body);

export const chargerKb = () => appel(BASE);
export const creerDossierApi = (body) => appel(`${BASE}/dossiers`, { method: "POST", body: corps(body) });
export const modifierDossierApi = (id, body) => appel(`${BASE}/dossiers/${id}`, { method: "PATCH", body: corps(body) });
export const supprimerDossierApi = (id) => appel(`${BASE}/dossiers/${id}`, { method: "DELETE" });
export const validerDossierApi = (id, on) => appel(`${BASE}/dossiers/${id}/validation`, { method: "POST", body: corps({ on }) });
export const ajouterSourceApi = (id, body) => appel(`${BASE}/dossiers/${id}/sources`, { method: "POST", body: corps(body) });
export const ajouterDocumentApi = (id, body) => appel(`${BASE}/dossiers/${id}/documents`, { method: "POST", body: corps(body) });
export const supprimerElementApi = (id) => appel(`${BASE}/elements/${id}`, { method: "DELETE" });
// Recherche intelligente : dossiers liés par le sens, avec une raison courte.
export const rechercheIntelligenteApi = (q) =>
  appel("https://backend-myalfa.vercel.app/api/kb/recherche-intelligente", { method: "POST", body: corps({ q }) });
export const basculerFavoriApi = (id) => appel(`${BASE}/dossiers/${id}/favori`, { method: "POST" });

// Envoi direct navigateur -> Vercel Blob (contourne la limite de 4,5 Mo des
// fonctions Vercel) ; le serveur ne reçoit que l'adresse du fichier. L'accès
// est contrôlé via le JWT passé en clientPayload.
export const televerserFichier = (file) =>
  upload(file.name, file, {
    access: "public",
    handleUploadUrl: `${BASE}/upload-token`,
    clientPayload: localStorage.getItem("token"),
  });
